module.exports = __webpack_public_path__ + "media/assets/images/pq3-53bd38d90d8217c32eedabfaf20b9466.svg";